var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_vm._v(" "+_vm._s(_vm.message)+" ")]),_c('v-row',{staticClass:"pt-4"},[_c('v-col'),_c('v-spacer'),_c('v-col',{staticClass:"pt-4"},[_c('v-btn',{staticClass:"cancel-move-scheduler",attrs:{"x-small":""},on:{"click":function($event){_vm.getElementById('cancel-move').click()}}},[_vm._v(_vm._s(_vm.buttonText))])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }